export const environment = {
  apiUrl: 'https://api.dev.betterchains.net',
  siteUrl: 'https://admin.dev.betterchains.net',
  staticUrl: '',
};
